import React from "react";
import { useNavigate } from "react-router-dom";
import ad2 from "../../Images/ad2.png";
import ad3 from "../../Images/ad3.png";

const adImage2 =
  "https://placehold.co/960x600/f3f4f6/aaaaaa?text=Advertisement";

const styles = `
  .mpimgad2-wrapper {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;
    margin-top: 20px;
  }
  .mpimgad2-item {
    flex: 1;
    aspect-ratio: 16/6;
    overflow: hidden;
    border-radius: 20px;
    cursor: pointer;
  }
  .mpimgad2-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  @media (max-width: 600px) {
    .mpimgad2-wrapper {
      flex-direction: column;
    }
    .mpimgad2-item {
      aspect-ratio: 16/6;
    }
  }
`;

export default function MPImageAd2() {
  const navigate = useNavigate();

  return (
    <>
      <style>{styles}</style>
      <div className="mpimgad2-wrapper">
        <div
          className="mpimgad2-item"
          onClick={() => navigate("/category/dubai-perfumes")}
        >
          <img src={ad2} alt="Advertisement" />
        </div>
        <div
          className="mpimgad2-item"
          onClick={() => navigate("/new-dubai-perfumes")}
        >
          <img src={ad3} alt="Advertisement" />
        </div>
      </div>
    </>
  );
}
